import { render, staticRenderFns } from "./PersonRow.vue?vue&type=template&id=fe7aa8f0&scoped=true"
import script from "./PersonRow.vue?vue&type=script&lang=ts"
export * from "./PersonRow.vue?vue&type=script&lang=ts"
import style0 from "./PersonRow.vue?vue&type=style&index=0&id=fe7aa8f0&prod&scoped=true&lang=css"
import style1 from "@/components/acquisitionList/ui/acquisitionViews.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/components/common/modern/modern.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "@/components/acquisitionList/ui/itemDetails.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "./profileUi.css?vue&type=style&index=4&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7aa8f0",
  null
  
)

export default component.exports